// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"41e61596","142":"e98a8884","330":"bd3deee5","361":"91c21b82","855":"372b10cd"}[chunkId] + ".chunk.css";
};